import React, { forwardRef } from "react"
import Form from "react-bootstrap/Form"

import SelectHybrid from "@atoms/SelectHybrid/SelectHybrid"

const FormFieldSelect = forwardRef(
  (
    {
      id,
      name,
      label,
      placeholder,
      required,
      description,
      disabled,
      isInvalid,
      native,
      options,
      ...props
    },
    ref
  ) => {
    const nativeItems = options?.map((option) => {
      return (
        <option key={option.value} value={option.value}>
          {option.text}
        </option>
      )
    })

    return (
      <Form.Group>
        {native && (
          <>
            <Form.Label htmlFor={id}>
              {label} {required && <>*</>}
            </Form.Label>
            <Form.Control
              name={name}
              id={id}
              as="select"
              disabled={disabled}
              isInvalid={isInvalid}
              ref={ref}
              {...props}
            >
              {nativeItems}
            </Form.Control>
            {description && (
              <Form.Text
                className={`${isInvalid ? "invalid-feedback" : "text-muted"}`}
              >
                {description}
              </Form.Text>
            )}
          </>
        )}
        {!native && (
          <SelectHybrid
            json={options}
            defaultValue={placeholder}
            description={description}
            label={label}
            id={id}
            isInvalid={isInvalid}
          />
        )}
      </Form.Group>
    )
  }
)

export default FormFieldSelect
